import appraiserAssignmentApproval from "apis/appraiserAssignmentApproval";
import { WebApiRequest, HTTP_GET, HTTP_PUT } from "tools/webservice";

export const getAppraiserAssignmentApproval = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: appraiserAssignmentApproval.getAssignmentApproval(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef
});

export const setAppraiserAssignmentApproval = (controlIdNumber, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  payload,
  endpoint: appraiserAssignmentApproval.setAssignmentApproval(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef
});
